import React from 'react';
import classnames from 'classnames';
import { Jumper } from 'tea-component';
import type { IBaseProps } from '@/pages/intelligence/types/common';
import './index.scss';

interface ISliderPagerProps extends IBaseProps {
  current: number;
  total: number;
  onChange?: (payload: number) => void;
}

const SliderPager: React.FC<ISliderPagerProps> = (props) => {
  const { style, className, current, total, onChange } = props;

  const prevDisabled = current <= 1;
  const nextDisabled = current >= total;

  const button = (
    <span>
      <span>{current}</span>
      <span className="dbi-slider-pager_pagination-label_spliter">/</span>
      <span>{total}</span>
    </span>
  );

  const handlePrev = () => {
    if (prevDisabled) return;
    onChange?.(current - 1);
  };

  const handleNext = () => {
    if (nextDisabled) return;
    onChange?.(current + 1);
  };

  return (
    <div style={style} className={classnames('dbi-slider-pager', className)}>
      <div className="dbi-slider-pager_pagination-label">{button}</div>
      <Jumper
        className="dbi-slider-pager_pagination"
        noBordered
        prevDisabled={prevDisabled}
        nextDisabled={nextDisabled}
        onPrev={handlePrev}
        onNext={handleNext}
      />
    </div>
  );
};

export default SliderPager;
